import { render, staticRenderFns } from "./MailServer.vue?vue&type=template&id=318c57d7&"
import script from "./MailServer.vue?vue&type=script&lang=js&"
export * from "./MailServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports